import axios from "axios";
import router from "../router";
import { Message } from "element-ui";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;
const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function (config) {
    // if (config.getHeaders().containsKey('Sec-WebSocket-Extensions')) {
    //   config.getHeaders().set('Sec-WebSocket-Extensions', 'permessage-deflate')
    // }
    // Do something before request is sent
    const company = router.app._route.params.company
      ? router.app._route.params.company
      : router.app._route.query.company;
    const info = localStorage.getItem(company);
    if (info) {
      const { token } = JSON.parse(info);
      config.headers.common.token = token;
    }
    return config;
  },
  function (error) {
    console.log("error", error);
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    // token超时
    if (response.data.status === 401) {
      Message.error(response.data.msg);
      const company = router.app._route.params.company
        ? router.app._route.params.company
        : router.app._route.query.company;
      localStorage.removeItem(company);
      sessionStorage.removeItem("token");
      router.push({ name: "Login", params: { company } });
    }
    return response;
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

// Plugin.install = function (Vue, options) {
//   Vue.axios = _axios
//   window.axios = _axios
//   Object.defineProperties(Vue.prototype, {
//     axios: {
//       get () {
//         return _axios
//       }
//     },
//     $axios: {
//       get () {
//         return _axios
//       }
//     }
//   })
// }

// Vue.use(Plugin)

// export default Plugin

/**
 *
 * @param {String} url
 * @param {Object} params
 * @param {Object} config
 * @returns
 */
export function get(url, params, config) {
  return new Promise((resolve, reject) => {
    _axios
      .get(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 *
 * @param {*} url
 * @param {*} params
 * @param {Object} config
 * @returns
 */
export function post(url, params, config) {
  return new Promise((resolve, reject) => {
    _axios
      .post(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 *
 * @param {*} url
 * @param {*} params
 * @param {Object} config
 * @returns
 */
export function put(url, params, config) {
  return new Promise((resolve, reject) => {
    _axios
      .put(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
/**
 * 由于delete是保留字，故没有统一名称
 * @param {*} url
 * @param {*} params
 * @param {Object} config
 * @returns
 */
export function deleteByAxios(url, params, config) {
  return new Promise((resolve, reject) => {
    _axios
      .delete(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
